// removed by extract-text-webpack-plugin
module.exports = {"menu":"_2Dz9e","item":"cvQty","itemSpinner":"_2m32r cvQty","spin":"_1VoQY","link":"_3psus","linkDisabled":"_1xFhV _3psus"};


//////////////////
// WEBPACK FOOTER
// ./src/components/menu/FooterMenu.css
// module id = 824
// module chunks = 0